<template>
  <div
    class="border-l-4 p-4 rounded-md"
    :class="{ 'border-red-400 bg-red-200': type === 'error', 'bg-yellow-50 border-yellow-400': type !== 'error' }"
  >
    <div class="flex">
      <div class="flex-shrink-0" v-if="type == 'error'">
        <XCircleIcon class="h-5 w-5 text-red-600" aria-hidden="true" />
      </div>
      <div class="flex-shrink-0" v-if="type == 'success'">
        <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
      </div>
      <div class="flex-shrink-0" v-if="type == 'alert'">
        <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <h3
          class="text-sm font-bold m-0 pt-1"
          :class="{ 'text-red-800': type === 'error', 'text-green-800': type !== 'error' }"
        >
          {{ title }}
        </h3>
        <div class="mt-2 text-sm text-black">
          <p>{{ message }}</p>
        </div>
        <div class="mt-2 text-sm text-black" v-if="html" v-html="htmlMessage"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';
import { XCircleIcon } from '@heroicons/vue/20/solid';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import { string } from 'yup';

export default {
  name: 'Alert',
  components: {
    ExclamationTriangleIcon,
    XCircleIcon,
    CheckCircleIcon
  },
  props: {
    type: {
      type: string,
      default: 'alert'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    html: {
      type: Boolean,
      default: false
    },
    htmlMessage: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {};
  }
};
</script>
